import { configFetch as fetch } from '@meiqia/utils';
import { ENV_CONFIG } from '@meiqia/constants';

export const getChannelListApi = () =>
  fetch({
    url: `/unified-api/team/v1/agent/sources`,
    method: 'get'
  });

export const getHasAuthAccountApi = () =>
  fetch({
    baseURL: ENV_CONFIG.JAVA_API_URL,
    url: `/omni/opendock/auth_info/has_success_auth_info`,
    method: 'get'
  }).then(res => res.data.data);
